/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgValuationTools32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1.66 2.659A2.25 2.25 0 013.25 2h23a2.25 2.25 0 012.25 2.25v15.448c.614.86.975 1.914.975 3.052 0 1.25-.436 2.398-1.164 3.3l3.499 3.734-1.095 1.026-3.503-3.739a5.204 5.204 0 01-2.974.929A5.244 5.244 0 0119 22.75a5.244 5.244 0 015.238-5.25c1.014 0 1.96.289 2.762.788V14.95l-3.838-.455.176-1.49L27 13.44V4.25a.75.75 0 00-.75-.75h-23a.75.75 0 00-.75.75v15.027l3.391-2.466a2.75 2.75 0 012.697-.306l3.74 1.596a1.25 1.25 0 001.341-.233l3.415-3.168 1.02 1.1-3.414 3.168a2.75 2.75 0 01-2.95.513L8 17.885a1.25 1.25 0 00-1.226.139L2.5 21.132v2.618a.748.748 0 00.75.75H17.5V26H3.25A2.248 2.248 0 011 23.75V4.25c0-.597.237-1.169.66-1.591zm22.578 16.34a3.744 3.744 0 00-3.738 3.75 3.744 3.744 0 003.738 3.75 3.744 3.744 0 003.737-3.75A3.744 3.744 0 0024.237 19zM16.022 8H5.5v1.5h10.522V8zM5.5 11h6v1.5h-6V11zM21.998 13a1.999 1.999 0 11-3.997 0 1.999 1.999 0 013.997 0z'
      />
    </svg>
  );
}

export default SvgValuationTools32;
